<template>
  <div class="p-1">
    <h3 class="text-2xl mb-2">Resumen de pagos</h3>
    <div class="flex flex-wrap justify-between items-center space-x-4 mb-4">
        <a-button @click="$router.back()" class="w-auto">
        Regresar
      </a-button>
      <a-button
        :to="{
          name: 'create_payment_setting',
          params: { id: $route.query.id },
        }"
        v-if="!user.isStudent && !user.isLowAdmin"
        class="md:w-auto"
      >
        Crear Configuraciones
      </a-button>
    </div>

    <a-table
      :columns="columns"
      :source="pagination.data"
      :loading="loading"
      :pagination="pagination"
      @paginate="search({ page: $event })"
      @delayed-filter:period="search({ page: 1, year_number: $event })"
      toolbar-column-filter
      @toolbar(refresh)="search({ page: 1 })"
    >
      <template #td(actions)="{ item }">
        <a-dropdown>
          <template #menu>
            <a-dropdown-item
              :to="{ name: 'details_payments', params: { id: item.id } }"
            >
              Ver detalles
            </a-dropdown-item>
            <template v-if="user.isAdmin">
              <a-dropdown-item
                :to="{
                  name: 'update_payment_setting',
                  params: { update: item.id },
                }"
              >
                Actualizar
              </a-dropdown-item>
              <a-dropdown-item @click="handleDelete(item.id)">
                Eliminar
              </a-dropdown-item>
            </template>
          </template>
        </a-dropdown>
      </template>
    </a-table>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    query: {
      limit: 10,
      search: "",
      year_number: "",
      sort_by: "year,desc",
      // with: 'artModel'
    },
    payment_type: {
      semester: "Semestre",
      courses: "Materia",
    },
    timeout: null,
    updating: [],
  }),
  computed: {
    ...mapState({
      user: (state) => state.session.user,
      pagination: (state) => state.periods.pagination,
      loading: (state) => state.periods.loading,
    }),
    columns() {
      return [
        {
          title: "Razón de pago",
          key: "type",
          mutate: ({ item }) =>
            `${this.payment_type[item.type]} ${
              item.type === "semester"
                ? item.target_semester
                : item.courses_count
            }`,
          visible: true,
          filter: true,
          preventLocalFilter: true,
          display: true,
        },
        // {
        //   title: "Valor al contado",
        //   key: "",
        //   visible: true,
        //   display: true,
        //   mutate: ({ item }) => `$${item.full_price}`,
        // },
        // {
        //   title: "Valor a crédito tardío",
        //   key: "",
        //   visible: true,
        //   display: true,
        //   mutate: ({ item }) => `$${item.credit_price}`,
        // },
        {
          title: "Cantidad de cuotas",
          key: "",
          visible: true,
          display: true,
          mutate: ({ item }) => `${item.installments}`,
        },
        {
          title: "Inscripción y primera mensualidad",
          key: "",
          visible: true,
          display: true,
          mutate: ({ item }) => `$${item.initial_price}`,
        },
        {
          title: "Valor de cada cuota",
          key: "",
          visible: true,
          display: true,
          mutate: ({ item }) => `$${item.installments_price}`,
        },
        {
          title: "Valor por pago tardío",
          key: "",
          visible: true,
          display: true,
          mutate: ({ item }) => `$${item.late_installment_extra}`,
        },
        // { title: 'Cantidad de cuotas', key: 'start_date', alignment: 'center', mutate: ({ item }) => this.$options.filters.date(item.start_date, 'DD-MM-YYYY'), visible: true, display: true },
        // { title: 'Inscripcion y primera mensualidad', key: 'end_date', alignment: 'right', mutate: ({ item }) => this.$options.filters.date(item.end_date, 'DD-MM-YYYY'), visible: true, display: true },
        // { title: 'Valor de cuotas restantes', key: 'first_half_end_date', alignment: 'right', visible: false, display: true },
        // { title: 'Valor por pago tardio', key: 'second_half_end_date', alignment: 'right', visible: false, display: true },
        {
          title: "Acciones",
          slot: "actions",
          alignment: "right",
          visible: true,
          columnFilterable: false,
          display: this.user.isAdminGroup,
        },
      ].filter(($0) => $0.display);
    },
  },
  methods: {
    ...mapActions({
      fetchPeriods: "periods/index",
      listPaymentSetting: "periods/listPaymentSetting",
      deletePaymentSetting: "periods/deletePaymentSetting",
      openInscriptions: "periods/openInscriptions",
    }),
    setOpenInscriptions(period) {
      this.$confirm({
        message: `¿Seguro que desea realizar esta acción?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.openInscriptions({
              ...period,
              enabled_inscriptions: !period.enabled_inscriptions,
              enabled_preregisters: period.enabled_preregisters,
            }).then(() => {
              this.search();
            });
          }
        },
      });
    },
    handleDelete(id) {
      Vue.prototype.$confirm({
        message: `¿Seguro que desea eliminar esta configuración de pago?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.deletePaymentSetting(id);
          }
        },
      });
    },
  },
  mounted() {
    this.listPaymentSetting(this.$route.query.id);

    // this.search({ ...this.query, page: this.$route.query.page || 1 })
  },
};
</script>
